export const AUTHENTICATED_ROOT = '(authenticated)';
export const UNAUTHENTICATED_ROOT = '(unauthenticated)';
